import {filter, omit} from "lodash"
import {SET_TEAMS, UPDATE_TEAM, ADD_TEAM, DELETE_TEAM} from "../actions/TeamActions"

const TeamsReducer = (state = {list: [], map: {}}, action) => {
  const {list} = action

  switch (action.type) {
    case SET_TEAMS:
      return getTeams(state, list)
    case UPDATE_TEAM:
      return updateTeam(state, action.team)
    case ADD_TEAM:
      return addTeam(state, action.team)
    case DELETE_TEAM:
      return deleteTeam(state, action.team)
    default:
      return state
  }
}

export default TeamsReducer

const getTeams = (state, list) => {
  const map = {}
  list.forEach((team) => {
    map[team.uuid] = team
  })

  return {
    ...state,
    list,
    map
  }
}

const updateTeam = (state, team) => {
  const {list, map} = state
  for (let i = 0; i < list.length; i++) {
    if (list[i].uuid === team.uuid) {
      list[i] = team
    }
  }
  map[team.uuid] = team
  return {
    ...state,
    list: [...list],
    map: {...map}
  }
}

const addTeam = (state, team) => {
  const newTeam = {}
  newTeam[team.uuid] = team

  return {
    ...state,
    list: [team, ...state.list],
    map: {...newTeam, ...state.map}
  }
}

const deleteTeam = (state, team) => {
  const list = filter(state.list, (test) => test.uuid !== team.uuid)
  const map = omit(state.map, [team.uuid])

  return {
    ...state,
    list,
    map
  }
}
